// i18n.js

import i18n, { loadLanguages } from 'i18next';
import { initReactI18next } from 'react-i18next';
// If you prefer to load translations from files:
// import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import translationGB from '../translations/gb.json';
import translationSE from '../translations/se.json';
// Add other languages as needed

const resources = {
  gb: { translation: translationGB },
  se: { translation: translationSE },
};

i18n
  // .use(Backend) // If loading translations via HTTP
  // .use(LanguageDetector) // If detecting user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'se', // Default language
    fallbackLng: 'gb', // Fallback language
    debug: true, // Set to false in production
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
